import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import type { ContextType } from "../../types/auth";
import { useAuth } from "../../hooks/useAuth";

interface RequireContextProps extends PropsWithChildren {
  type: ContextType;
}

function resolveFallbackPath(currentType: ContextType | undefined): string {
  if (!currentType) {
    return "/login";
  }

  return "/dashboard";
}

export function RequireContext({ type, children }: RequireContextProps) {
  const { user, isInitialized, isLoading } = useAuth();
  if (!isInitialized || isLoading) {
    return <div>Loading...</div>;
  }
  const currentType = user?.type;

  if (currentType !== type) {
    return <Navigate to={resolveFallbackPath(currentType)} replace />;
  }

  return <>{children}</>;
}
